<template>
  <div class="sjj">
    <v-LeftSource> </v-LeftSource>
    <div class="viewSet" v-loading="allLoad">
      <div class="leftSet">
        <!-- <div class="leftTil">
          <FSpanTil title="" fontSize="16">{{viewSet.activeType.dateSourceName || ''}}</FSpanTil>
          <div class="divSvg">
            <FSvg title="刷新" color="#666" IconSize="22" @click.native="getDialog(0)"></FSvg>
          </div>
        </div> -->
        <FSpanTil IconSize="20" title="OData数据接入"></FSpanTil>
        <div class="leftList">
          <div class="list_til noSelect">
            <div class="divSvg">
              <FSvg title="刷新" color="#fff" hoverColor="#fff" IconSize="20"></FSvg>
            </div>
            <span class="divSpan">数据准备列表</span>
          </div>
          <div class="listUl_count" v-loading="viewSet.load">
            <!-- <ul class="listUl" v-if="viewSet.valList.length">
              <li v-for="(item,index) in viewSet.valList" :class="{addValList:activeViewSet.id===item.id}" @click="getViewListClick(item.id)">
                {{item.dataSetName}}
              </li>
            </ul> -->
            <div class="comNoData"><span>暂无数据</span></div>
          </div>
        </div>
      </div>
      <div class="add_del">
        <FBtn @click="getDialog(0)">添加</FBtn>
        <FBtn type="4" disabled class="FBtn_type_del">删除</FBtn>
      </div>
      <div class="rigSet2" v-loading="viewSetDP.load">

        <div class="rigTil">
          <div>
            <FSvg title="图表" color="#333" hoverColor="#333"></FSvg>
          </div>
          <!-- <span>{{activeViewSet.name}}</span> -->
          <span></span>
        </div>
        <div class="rigCount">
          <!-- <div class="rigCount_div" v-if="viewSet.valList.length">
            <div class="dp_forList" v-for="item in viewSetDP.list">
              <div class="chart_div">
                <div class="div_count">
                  <div class="div_til">
                    <span>{{item.dataViewName}}</span>
                    <div style="margin-right: 0" @click="getAddRoute(item.id)">
                      <FSvg title="编辑" color="#999" IconSize="15"></FSvg>
                    </div>
                    <div style="margin-top: 0" @click="getRemoveDP(item.id)">
                      <FSvg title="删除" color="#999" IconSize="17"></FSvg>
                    </div>
                  </div>
                  <div class="div_img">
                    <img :src="item.previewPicture" ondragstart="return false" @error="imgError">
                  </div>
                </div>
              </div>
            </div>
            <div class="dp_forList addList_div" v-show="activeViewSet.id" @click="getAddRoute()">
              <div class="chart_div">
                <div class="div_count">
                  <div class="div_svg">
                    <FSvg title="加" IconSize="60" color="#ddd" hoverColor="#ddd"></FSvg>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="comNoData"><span>暂无数据</span></div>
        </div>
      </div>
      <!--切换类型-->
      <FDialog class="viewSet_dialog" :dialog="viewSetDialog.show" title="OData数据接入" @close="getDialog(1)" moveWidth="570px">
        <!-- <div class="type_radio">
            <span :class="{addSpan:viewSetDialog.type===1}" @click="getDialogType(1)">MYSQL</span>
            <span :class="{addSpan:viewSetDialog.type===2}" @click="getDialogType(2)">SQL SERVER</span>
            <span :class="{addSpan:viewSetDialog.type===3}" @click="getDialogType(3)">ORACLE</span>
            <span :class="{addSpan:viewSetDialog.type===0}" @click="getDialogType(0)">EXCEL</span>
            <span :class="{addSpan:viewSetDialog.type===4}" @click="getDialogType(4)">达梦</span>
            <span :class="{addSpan:viewSetDialog.type===5}" @click="getDialogType(5)">金仓</span>
          </div>
          <div class="div_radio">
            <el-radio-group v-model="viewSetDialog.id">
              <el-radio v-for="item in viewSetDialog.typeList" :label="item.id" v-show="viewSetDialog.type===item.type">
                {{item.dateSourceName}}
              </el-radio>
            </el-radio-group>
          </div> -->
        <!-- <div class="div_btn">
            <FBtn type="1" @click="getDialogReset">重置</FBtn>
            <FBtn type="3" @click="getDialog(2)" :disabled="viewSetDialog.id===viewSet.id">确定</FBtn>
          </div> -->
        <div class="details_dialog_form">
          <el-form label-width="125px">
            <el-form-item label="服务器：">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="端口：">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="请求方式：">
              <el-select v-model="options1" placeholder="请选择">
                <el-option v-for="item in optionsList1" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btnRight">
          <FBtn type="2" class="btnTest">连接</FBtn>
        </div>
      </FDialog>
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/4/7 2:53 下午
 */
import {
  GetDataSourceList,
  GetConnByDataSource,
  GetDataSetList,
  GetDataViewListByDataSet,
  RemoveDataView,
  GetSnapShotVerify,
  SetSnapShot
} from '@/assets/axios/dataUpload/viewSet';
import vLeftSource from '@/components/LeftSource/LeftSource.vue'


export default {
  name: 'viewSet',
  components: {
    vLeftSource,
  },
  props: {},
  data() {
    return {
      optionsList1: ["GET", "POST"],
      options1: "",

      //全局刷新
      allLoad: false,
      //数据准备
      viewSet: {
        //数据接入id
        id: '',
        load: true,
        //选中的数据接入信息
        activeType: {},
        valList: [],
      },
      //选中的数据
      activeViewSet: {
        id: '',
        name: ''
      },
      //多维分析大屏
      viewSetDP: {
        load: true,
        list: []
      },
      //弹框切换类型
      viewSetDialog: {
        id: '',
        show: false,
        type: 1,
        typeList: [],
      },
    }
  },
  methods: {
    //获取数据
    async init() {
      let dataSetId = this.getSession('view_setId_xy') || '';
      let id = this.getSession('view_source_xy') || '';
      if (id) {
        this.viewSet.id = id;
        if (dataSetId) {
          this.activeViewSet.id = dataSetId;
        } else {
          this.activeViewSet.id = '';
          this.getSoSet(1, '');
        }
      } else {
        this.viewSet.id = '';
        this.getSoSet(0, '');
      }

      await this.viewSetDialogList();
      if (!this.viewSet.activeType.id) {
        return
      }
      await this.getViewSetNextAll();
    },
    //根据数据接入查询之后逻辑
    async getViewSetNextAll() {
      if (await this.getTestViewSet()) {
        await this.getViewSetList();
        await this.getViewDPList();
      } else {
        this.getLoadNoData();
      }
    },
    //清空所有数据
    async getLoadNoData() {
      this.viewSet.valList = [];
      this.viewSetDP.list = [];
      this.viewSet.load = false;
      this.viewSetDP.load = false;
      this.activeViewSet = {
        id: '',
        name: ''
      };
    },
    //测试是否可以连接数据接入
    async getTestViewSet() {
      let bool = false;
      this.allLoad = true;
      await GetConnByDataSource({
        dataSourceID: this.viewSet.id
      }).then(res => {
        if (res.code === 200) {
          bool = true;
        }
      }).catch(() => {
      });
      setTimeout(() => {
        this.allLoad = false;
      }, 300);
      return bool;
    },
    //图片加载失败
    imgError(event) {
      let index = this.randomNum(1, 1).toFixed(0);
      $(event.target).attr('src', require(`./img/viewCharts/${index}.png`))
    },
    /*- - - - - - - - - - 数据接入弹框 - - - - - - - - - - - - - - -*/
    //数据接入弹框
    async getDialog(type) {
      if (type === 0) {
        this.getDialogReset();
        this.viewSetDialog.show = true;
      } else if (type === 1) {
        this.viewSetDialog.show = false;
      } else if (type === 2) {
        this.viewSetDialog.show = false;
        if (this.viewSetDialog.id !== this.viewSet.id) {
          this.activeViewSet.id = '';
          this.viewSet.id = this.viewSetDialog.id;
          await this.getDialogRadioChange();
          await this.getViewSetNextAll();
        }
      }
    },
    //数据接入弹框 数据列表
    async viewSetDialogList() {
      this.allLoad = true;
      await GetDataSourceList().then(res => {
        if (res.code === 200) {
          this.viewSetDialog.typeList = res.data.dataTabel;
          if (this.viewSet.id) {
            this.getDialogRadioChange();
          } else {
            if (this.viewSetDialog.typeList.length) {
              let id = '';
              let count = 0;
              this.viewSetDialog.typeList.map(item => {
                if (count !== 0) {
                  return;
                }
                if (item.type === 1) {
                  id = item.id;
                  count = 1;
                }
              });
              if (count === 0) {
                this.dataSetDialog.typeList.map(item => {
                  if (count !== 0) {
                    return;
                  }
                  if (item.type === 2) {
                    id = item.id;
                    count = 1;
                  }
                });
              }
              if (count === 0) {
                this.dataSetDialog.typeList.map(item => {
                  if (count !== 0) {
                    return;
                  }
                  if (item.type === 3) {
                    id = item.id;
                    count = 1;
                  }
                });
              }
              if (count === 0) {
                this.dataSetDialog.typeList.map(item => {
                  if (count !== 0) {
                    return;

                  }
                  if (item.type === 0) {
                    id = item.id;
                    count = 1;
                  }
                });
              }
              this.viewSet.id = id;
              this.getDialogRadioChange();
            }
          }
        } else {
          this.viewSetDialog.typeList = [];
        }
      });
      setTimeout(() => {
        this.allLoad = false;
      }, 300)
    },
    //数据接入弹框 切换数据
    getDialogRadioChange() {
      this.viewSet.activeType = {};
      this.viewSetDialog.typeList.map((item) => {
        if (item.id === this.viewSet.id) {
          this.viewSet.activeType = item;
        }
      });
      this.getSoSet(0, this.viewSet.id);
    },
    //数据接入弹款 切换类型
    getDialogType(type) {
      if (type === this.viewSetDialog.type) {
        return;
      }
      this.viewSetDialog.type = type;
    },
    //数据接入弹款 重置
    getDialogReset() {
      this.viewSetDialog.id = this.viewSet.id;
      this.viewSetDialog.typeList.map((item) => {
        if (item.id === this.viewSetDialog.id) {
          this.viewSetDialog.type = item.type;
        }
      });
    },
    /*- - - - - - - - - - 数据准备 - - - - - - - - - - - - - - -*/
    async getViewSetList() {
      this.viewSet.load = true;
      await GetDataSetList({
        pageIndex: 1,
        pageSize: 99999,
        dataSourceID: this.viewSet.id,
      }).then(async res => {
        if (res.code === 200) {
          if (res.data) {
            this.viewSet.valList = res.data.dataTabel || [];
            if (this.viewSet.valList.length) {
              if (!this.activeViewSet.id) {
                this.activeViewSet.id = this.viewSet.valList[0].id;
              }
            } else {
              this.activeViewSet.id = '';
            }
          } else {
            this.viewSet.valList = [];
          }
          await this.getCheckViewSet(this.activeViewSet.id);
        } else {
          this.viewSet.valList = [];
        }
      }).catch(() => {
      });
      setTimeout(() => {
        this.viewSet.load = false;
      }, 300)
    },
    //获取选中的数据
    getCheckViewSet(id) {
      if (!id) {
        this.activeViewSet.id = '';
        this.activeViewSet.name = '';
      }
      this.viewSet.valList.map((item) => {
        if (item.id === id) {
          this.activeViewSet.id = item.id;
          this.activeViewSet.name = item.dataSetName;
        }
      });
      this.getSoSet(1, this.activeViewSet.id);
    },
    //点击数据准备列表
    async getViewListClick(id) {
      if (id === this.activeViewSet.id) {
        return;
      }
      await this.getCheckViewSet(id);
      await this.getViewDPList();
    },
    /*- - - - - - - - - - 多维分析 - - - - - - - - - */
    //获取多维分析信息
    async getViewDPList() {
      this.viewSetDP.load = true;
      await GetDataViewListByDataSet({
        dataSetID: this.activeViewSet.id
      }).then(res => {
        if (res.code === 200) {
          this.viewSetDP.list = res.data.dataTabel;
          this.viewSetDP.list = this.viewSetDP.list.map((item) => {
            return {
              dataViewName: item.dataViewName,
              id: item.id,
              previewPicture: item.previewPicture || '',
            }
          })
        }
      });
      setTimeout(() => {
        this.viewSetDP.load = false;
      }, 300)
    },
    //创建图表
    async getAddRoute(id) {
      await this.getSoSet(2, (id || ''));
      this.$router.push('/createViewDP2');
    },
    //删除多维分析
    getRemoveDP(id) {
      this.$alert('是否删除多维分析?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
      }).then(() => {
        RemoveDataView({ viewIDs: id }).then(res => {
          if (res.code === 200) {
            this.getMsg('删除成功', 'success');
            this.getViewDPList();
          }
        })
      }).catch(() => {

      });
    },
    //添加快照
    async getKZRoute(id) {
      if (await this.getKZCheck(id)) {
        SetSnapShot({
          dataViewID: id,
        }).then(res => {
          if (res.code === 200) {
            this.getMsg('新增快照成功', 'success')
          }
        }).catch(() => {
        })
      }
    },
    //快照重复校验
    async getKZCheck(id) {
      let bool = false;
      await GetSnapShotVerify({ dataViewID: id }).then(res => {
        if (res.code === 200) {
          bool = true;
        }
      });
      return bool;
    }
  },
  mounted() {
    this.init();
  },
  destroyed() {

  }
}
</script>

<style lang="less">
@borderRadio: 5px;
@borderColor: #ccc;
@shadow: 0 0 15px @h_top_backColor;

.viewSet {
  overflow: hidden;
  margin-right: 1%;
  // position: relative;
  // background-color: @h_main_backColor !important;
  // padding: 0 !important;
  // width: 1690px;
  // min-height: 800px;
  // background-color: #e0e1ec;
  border-radius: 10px;
  // margin-left: 220px;
  //   overflow: hidden;
  // width: 100%;
  // margin-right: 1%;
  background-color: #eaebf7;
  // border-radius: 10px;
  padding-bottom: 20px;

  .leftSet {
    width: 16%;
    height: 100%;
    margin-right: 1%;
    float: left;
    display: inline-block;
    padding: 20px;
    .noSelect;

    .leftTil {
      background-color: @h_path_backColor;
      padding: 2px 5px;
      line-height: 30px;
      position: relative;
      border-radius: 10px;

      .FSpanTil {
        vertical-align: middle;
        max-width: 85%;

        .div_svg {
          margin-top: 0;
        }
      }

      .divSvg {
        display: inline-block;
        float: right;
        width: 30px;
        height: 30px;
      }
    }

    .leftList {
      margin-top: 15px;
      display: inline-block;
      width: 100%;
      height: calc(100% - 15px - 30px - 14px);
      background-color: @h_path_backColor;
      border-radius: @borderRadio;

      .list_til {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-top-right-radius: @borderRadio;
        border-top-left-radius: @borderRadio;
        // background-color: hsl(@green, 90%);
        background-color: #002774;
        padding: 0 10px;
        white-space: normal;

        .divSvg {
          display: inline-block;
          float: left;
          width: 30px;
          height: 30px;
          margin-top: -3px;

          > .FSvg {
            cursor: auto;
          }
        }

        .divSpan {
          color: #fff;
          display: inline-block;
          width: calc(100% - 60px);
          .text_oneLine;
          float: left;
          font-size: 16px;
          letter-spacing: 2px;
        }
      }

      .listUl_count {
        width: 100%;
        height: calc(100% - 40px);
        overflow-y: auto;
        overflow-x: hidden;

        .listUl {
          width: 100%;
          height: 100%;

          > li {
            // width: 100%;
            // line-height: 40px;
            // padding: 0 10px;
            // color: hsl(@fontColor, 0.8);
            // font-size: 16px;
            // cursor: pointer;
            // letter-spacing: 1px;
            width: 100%;
            line-height: 40px;
            padding: 0 10px;
            color: #999;
            font-size: 14px;
            cursor: pointer;
            letter-spacing: 1px;
            .text_oneLine;
            .text_oneLine;
          }

          > li:hover {
            // background-color: hsl(@green, 10%);
            background: rgba(0, 39, 116, 0.3);
            color: #fff;
          }

          .addValList {
            // background-color: hsl(@green, 30%) !important;
            position: relative;
          }

          .addValList::after {
            position: absolute;
            bottom: 4px;
            left: 0px;
            height: 30px;
            width: 2px;
            content: "";
            -webkit-transform: scaleY(0.5);
            background-color: #0c0c54;
          }
        }
      }
    }
  }
  .add_del {
    margin-right: 3%;
    margin-top: 30px;
    float: right;
  }
  .rigSet2 {
    background-color: @h_path_backColor;
    border-radius: @borderRadio;
    // min-height: 710px;
    width: 80%;
    float: left;
    display: inline-block;
    padding: 5px 5px 20px;
    margin-top: 22px;

    > .rigTil {
      line-height: 30px;
      padding: 10px 15px 0;

      > div {
        display: inline-block;
        float: left;
        vertical-align: middle;
        margin-top: -2px;
      }

      > span {
        display: inline-block;
        margin-left: 10px;
        color: @fontColor;
        float: left;
        font-size: 20px;
        letter-spacing: 2px;
      }
    }

    > .rigCount {
      width: 100%;
      height: calc(100% - 50px);
      padding: 15px;
      overflow-y: auto;
      overflow-x: hidden;

      .rigCount_div {
        width: calc(100% + 20px);
        height: 100%;

        .dp_forList {
          width: 285px;
          float: left;
          position: relative;
          padding-bottom: calc(285px * 0.7);
          border-radius: @borderRadio;
          margin-right: 15px;
          margin-bottom: 15px;
          background-color: @h_path_backColor;

          .chart_div {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: @borderRadio;
            cursor: pointer;
            border: 1px solid @borderColor;

            > .div_count {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 2;
              padding-bottom: 10px;

              > .div_til {
                width: 100%;
                border-top-right-radius: @borderRadio;
                border-top-left-radius: @borderRadio;
                height: 37px;
                padding: 0 3%;
                font-size: 14px;
                letter-spacing: 1px;
                position: relative;

                > span {
                  display: inline-block;
                  max-width: 70%;
                  float: left;
                  color: #999;
                  font-size: 16px;
                  .com_middle;
                  .text_oneLine;
                }

                > div {
                  width: 18px;
                  height: 18px;
                  float: right;
                  display: inline-block;
                  margin-right: 10px;
                  .com_middle;
                  margin-top: 1px;
                }
              }

              > .div_img {
                width: 100%;
                height: calc(100% - 15%);
                position: relative;

                > img {
                  max-width: 60%;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translateY(-50%) translateX(-50%);
                }
              }

              > .div_svg {
                display: inline-block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
              }
            }
          }
        }

        .dp_forList:hover {
          box-shadow: @shadow;
        }

        .addList_div:hover {
          box-shadow: @shadow;

          svg {
            fill: @green !important;
          }
        }
      }
    }
  }

  .viewSet_dialog {
    .el-dialog {
      .details_dialog_form {
        padding: 10px 0;
        position: relative;

        .el-form {
          width: 100%;
          height: 100%;
          padding: 20px 0 20px 0;
        }
      }
      .btnRight {
        text-align: center;
        margin-bottom: 30px;
      }
      .el-dialog__body {
        height: 310px;
        padding: 0 !important;
      }
    }
    .database {
      width: 100%;
      .kind {
        width: 100%;
        padding: 22px 116px;
        border-bottom: 1px dashed #dcdcdc;
        .el-radio-group {
          width: 100%;
        }
        use {
          width: 16px;
          height: 16px;
          display: inline-block;
        }
      }
      .kind:last-child {
        margin-bottom: 20px;
        border-bottom: 1px solid #dcdcdc;
      }
      .el-radio__inner {
        display: none;
      }
    }
    .details_dialog .el-radio__input.is-checked + .el-radio__label {
      color: #fff;
      background: #1d224c;
    }
    .el-input {
      position: relative;
      font-size: 14px;
      display: inline-block;
      width: 85%;
    }
    .el-input__inner {
      border: none;
      border-radius: 0px;
      border-bottom: 1px solid #ccc;
      width: 60%;
    }
    .el-form-item {
      margin-left: 100px;
    }
  }
}
</style>
